"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMoleculeWithH = getMoleculeWithH;
const ensureHeterotopicChiralBonds_js_1 = require("../diastereotopic/ensureHeterotopicChiralBonds.js");
/**
 * Expand all the implicit hydrogens and ensure chiral bonds on heterotopic bonds
 * @param molecule
 * @returns
 */
function getMoleculeWithH(molecule, options = {}) {
    const { maxNbAtoms = 250 } = options;
    const moleculeWithH = molecule.getCompactCopy();
    moleculeWithH.addImplicitHydrogens();
    if (moleculeWithH.getAllAtoms() > maxNbAtoms) {
        throw new Error(`too many atoms to add hydrogens: ${moleculeWithH.getAllAtoms()} > ${maxNbAtoms}`);
    }
    (0, ensureHeterotopicChiralBonds_js_1.ensureHeterotopicChiralBonds)(moleculeWithH);
    return moleculeWithH;
}
//# sourceMappingURL=getMoleculeWithH.js.map